import ExcelJS from 'exceljs';

export const generateTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Student Upload');

  // Define columns
  worksheet.columns = [
    { header: 'parent1_firstname', key: 'parent1_firstname', width: 20 },
    { header: 'parent1_lastname', key: 'parent1_lastname', width: 20 },
    { header: 'parent1_email', key: 'parent1_email', width: 25 },
    { header: 'parent1_phone', key: 'parent1_phone', width: 15 },
    { header: 'parent2_firstname', key: 'parent2_firstname', width: 20 },
    { header: 'parent2_lastname', key: 'parent2_lastname', width: 20 },
    { header: 'parent2_email', key: 'parent2_email', width: 25 },
    { header: 'parent2_phone', key: 'parent2_phone', width: 15 },
    { header: 'student_firstname', key: 'student_firstname', width: 20 },
    { header: 'student_lastname', key: 'student_lastname', width: 20 },
    { header: 'student_dob', key: 'student_dob', width: 15 },
    { header: 'program_start_date', key: 'program_start_date', width: 18 },
  ];

  // Define which columns are required
  const requiredColumns = [1, 2, 3, 4, 9, 10, 11, 12]; // Column indices (1-based)

  // Style header row
  const headerRow = worksheet.getRow(1);
  headerRow.eachCell({ includeEmpty: false }, (cell, colNumber) => {
    const isRequired = requiredColumns.includes(colNumber);
    
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: isRequired ? 'FFFFE6E6' : 'FFFFFFF9E6' }
    };
    
    cell.font = {
      bold: true,
      color: { argb: isRequired ? 'FFCC0000' : 'FFCC8800' }
    };
    
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // Add sample data
  worksheet.addRow({
    parent1_firstname: 'John',
    parent1_lastname: 'Doe',
    parent1_email: 'john.doe@email.com',
    parent1_phone: '555-555-5555',
    parent2_firstname: 'Jane',
    parent2_lastname: 'Doe',
    parent2_email: 'jane.doe@email.com',
    parent2_phone: '555-555-5556',
    student_firstname: 'Tommy',
    student_lastname: 'Doe',
    student_dob: '2015-03-15',
    program_start_date: '2025-09-01',
  });

  // Generate buffer
  const buffer = await workbook.xlsx.writeBuffer();
  return new Blob([buffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
};